import {
  CreateVersionRequestDto,
  CreateVersionResponseDto,
  FlowVersionDetailDto,
  FlowVersionsListDto,
  PushToProductionResponseDto,
  RollbackResponseDto,
  VersionHistoryListDto,
} from '../types/FlowVersion';
import { ApiService } from './ApiService';

export class FlowVersionService extends ApiService {
  static basePath = '/flow';

  static getDeployedVersion(flowId: string): Promise<FlowVersionDetailDto> {
    return this.get<FlowVersionDetailDto>(
      `${this.basePath}/${flowId}/versions/deployed`,
    );
  }

  static createVersion(
    flowId: string,
    data: CreateVersionRequestDto,
  ): Promise<CreateVersionResponseDto> {
    return this.post<CreateVersionResponseDto>(
      `${this.basePath}/${flowId}/versions/create`,
      data,
    );
  }

  static pushToProduction(
    flowId: string,
    versionId: string,
  ): Promise<PushToProductionResponseDto> {
    return this.post<PushToProductionResponseDto>(
      `${this.basePath}/${flowId}/versions/push-to-production`,
      { versionId },
    );
  }

  static rollback(
    flowId: string,
    versionId: string,
    historyId: string,
  ): Promise<RollbackResponseDto> {
    return this.post<RollbackResponseDto>(
      `${this.basePath}/${flowId}/versions/rollback`,
      { versionId, historyId },
    );
  }

  static getVersions(
    flowId: string,
    page: number = 1,
    pageSize: number = 10,
  ): Promise<FlowVersionsListDto> {
    return this.get<FlowVersionsListDto>(
      `${this.basePath}/${flowId}/versions`,
      undefined,
      undefined,
      { page, pageSize },
    );
  }

  static getVersionHistory(
    flowId: string,
    versionId: string,
    page: number = 1,
    pageSize: number = 10,
  ): Promise<VersionHistoryListDto> {
    return this.get<VersionHistoryListDto>(
      `${this.basePath}/${flowId}/versions/${versionId}/history`,
      undefined,
      undefined,
      { page, pageSize },
    );
  }
}
